import React from "react";
import DashboardWidgetCard from "./components/DashboardWidgetCard";
import DashboardCardHeader from "./components/DashboardCardHeader";
import ToggleButtonsTrasnferList from "./components/ToggleButton";
import { makeStyles } from "@material-ui/core";
import Loading from "./components/Loading";
import ResponsiveBarChart from "./components/ResponsiveBarChart";
import { formatDate } from "./helper/format";

const monthName = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const useStyle = makeStyles((theme) => {
  return {
    card: { margin: theme.spacing(2, 0) },
    cardHeader: {
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      paddingBottom: theme.spacing(2),
      marginTop: theme.spacing(0.5),
    },
    updateDate: {
      color: "rgba(54, 43, 115, 0.56)",
      margin: "0",
      fontSize: 12,
    },
    container: {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    widget: {
      background: "white",
      borderRadius: theme.spacing(1.5),
      margin: theme.spacing(0, 1, 2),
      width: "calc(25% - 16px)",
      textAlign: "center",
      padding: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        width: "calc(50% - 16px)",
      },
    },
    chartContainer: {
      height: 440,
      marginTop: theme.spacing(2),
      overflowX: "auto",
      position: "relative",
    },
    chartWrapper: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      height: 420,
      minWidth: 1000,
    },
    filtersContent: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
      },
    },
  };
});

export default function DaywiseActiveMerchant({ merchantData, isLoading }) {
  const [tabIndex, setTabIndex] = React.useState(0);
  const [overallTabIndex, setOverallTabIndex] = React.useState(0);
  const classes = useStyle();
  const tabConfig = [
    { label: "Any Amount", id: "ACTIVE_MERCHANT_ANY_AMT" },
    {
      label: "Qualified (5 MAU 1500 Payment)",
      id: "ACTIVE_MERCHANT_QUALIFIED",
    },
  ];

  const overallTabConfig = [
    // { label: "Eligible", id: "_ELIGIBLE" },
    { label: "Overall", id: "_LASTDAY" },
  ];

  const onTabChange = (index) => {
    if (index == null) return;
    if (index >= 0 && index < tabConfig.length) {
      setTabIndex(index);
    }
  };

  // const onTabChangeOverall = (index) => {
  //   if (index == null) return;
  //   setOverallTabIndex(index);
  // };

  const generateData = (data) => {
    const id = tabConfig[tabIndex].id + overallTabConfig[overallTabIndex].id;
    let result = [];

    const d = new Date();
    const month = d.getMonth();
    const year = d.getFullYear();
    const lastMonth = (month - 1 + 12) % 12;

    data.current_month.forEach((c) => {
      result.push({
        "Active Merchant": c[id],
        name: c.DATE.slice(-2) + " " + monthName[month],
        date: c.DATE,
        month,
      });
    });

    data.last_month.forEach((c) => {
      result.push({
        "Active Merchant": c[id],
        name: c.DATE.slice(-2) + " " + monthName[lastMonth],
        date: c.DATE,
        month: lastMonth,
      });
    });

    const sortedResult = result.sort((a, b) => {
      const A = new Date(a.date);
      const B = new Date(b.date);

      // if (a.month > b.month) {
      //   return 1;
      // } else if (a.month < b.month) {
      //   return -1;
      // }
      if (A > B) {
        return 1;
      } else if (A < B) {
        return -1;
      }

      return a.day - b.day;
    });

    return sortedResult.slice(-30);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {merchantData && (
        <DashboardWidgetCard className={classes.card}>
          <DashboardCardHeader
            className={classes.cardHeader}
            label="Day wise Active Merchant"
            subLabel={
              merchantData && (
                <p className={classes.updateDate}>
                  Updated till - {formatDate(merchantData.last_parsed_time)}
                </p>
              )
            }
          ></DashboardCardHeader>
          <div className={classes.filtersContent}>
            <ToggleButtonsTrasnferList
              config={tabConfig}
              tabIndex={tabIndex}
              onTabChange={onTabChange}
            />
            {/*<ToggleButtonsTrasnferList
              config={overallTabConfig}
              tabIndex={overallTabIndex}
              onTabChange={onTabChangeOverall}
            />*/}
          </div>
          <div className={classes.chartContainer}>
            <div className={classes.chartWrapper}>
              <ResponsiveBarChart
                data={generateData(merchantData)}
                labelX={"name"}
                labelY={"Active Merchant"}
              />
            </div>
          </div>
        </DashboardWidgetCard>
      )}
    </>
  );
}
